<div class="parent">
    <div class="searchBox">

        <input class="searchInput" type="text" name="" placeholder="Search" (input)="tcode=$event.target.value">
        <button class="searchButton" href="#" (click)="submit()">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search" width="44" height="44"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="#00abfb" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="10" cy="10" r="7" />
                <line x1="21" y1="21" x2="15" y2="15" />

                search
            </svg>
        </button>
    </div>
</div>